import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";

import { toRefs } from 'vue';
const _hoisted_1 = {
  class: "content"
};
export default /*@__PURE__*/_defineComponent({
  __name: 'XFlexCtx',
  props: {
    flex: {}
  },
  setup(__props) {
    const prop = __props;
    const {
      flex
    } = toRefs(prop);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        style: _normalizeStyle({
          flex: _unref(flex) + ''
        }),
        class: "ctx"
      }, [_createElementVNode("div", _hoisted_1, [_renderSlot(_ctx.$slots, "default")])], 4);
    };
  }
});